import { useState, useEffect } from "react";
import { loadMaterialCategoryList } from "../services/materialCategory";

const useMaterialCategory = (editID) => {

    const [materialCategory, setMaterialCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryID, setSelectedCategoryID] = useState(null);
    const [isMaterialCategoryDataLoaded, setIsMaterialCategoryDataLoaded] = useState(false);

    // Fetch department data
    const fetchMaterialCategory = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await loadMaterialCategoryList(para);
            if (data && data.length > 0) {
                setMaterialCategory(data);

                 if (selectedID===0){
                     setSelectedCategory(null);
                     setSelectedCategoryID(null);
                     setIsMaterialCategoryDataLoaded(true);
                 }
                 else{
                    const initialMaterialCategory = data.find((dept) => dept.id_material_category === selectedID);
                    // const initialDepartment = data.find((dept) => dept.id === selectedID) || data[0];
                    if (initialMaterialCategory) { // ✅ Corrected check
                        setSelectedCategory(initialMaterialCategory);
                        setSelectedCategoryID(initialMaterialCategory.id_material_category);
                        setIsMaterialCategoryDataLoaded(true);
                    }
    
                 }

                
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isMaterialCategoryDataLoaded && editID === 0) {
            fetchMaterialCategory();
        }
    }, [isMaterialCategoryDataLoaded, editID]);

    // Function to load department based on selected ID
    const loadMaterialCategoryByID = async (selectedID) => {
        await fetchMaterialCategory(selectedID);
    };

    return {
        materialCategory,
        selectedCategory,
        selectedCategoryID,
        setSelectedCategory,
        setSelectedCategoryID,
        loadMaterialCategoryByID,
    };
};

export default useMaterialCategory;
